export default __webpack_public_path__ + "img/dFwjeMaP.c774877f.svg";